import { render, staticRenderFns } from "./CellTextarea.vue?vue&type=template&id=29f88e2e&scoped=true"
import script from "./CellTextarea.vue?vue&type=script&lang=js"
export * from "./CellTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f88e2e",
  null
  
)

export default component.exports